import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=1c95a584&scoped=true"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"
import style0 from "./Stage.vue?vue&type=style&index=0&id=1c95a584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95a584",
  null
  
)

export default component.exports